import {getFlattenContacts, getUniqueContacts} from './normalizeFilters';

const getMappedContacts = (list) =>
	list.map((contact) => ({
		...contact
	}));

export const getMappedEntities = (list, orgChart) => {
	return list.map((contact) => {
		let entities = [];
		orgChart.forEach((entity) => {
			if (entity?.contacts && entity.contacts?.some(({emailAddress}) => emailAddress === contact?.emailAddress)) {
				entities.push({label: entity.label, id: entity.id, entityId: entity.entityId});
			}
		});
		return {...contact, entities: [...entities]};
	});
};

export default (list) => getMappedContacts(getMappedEntities(getUniqueContacts(getFlattenContacts(list)), list));
